import { Injectable } from '@angular/core';
import { JourneyService } from '../../shared/service/journey/journey.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileDataService {

  private readonly STEP_CODE = 'profile';

  constructor(private journeyService: JourneyService) {
  }

  public setDocumentNameData(name: string) {
    this.journeyService.registratioJourney.data.profileData.name = name;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.profileData);
  }

  public setDocumentEmailData(email: string) {
    this.journeyService.registratioJourney.data.profileData.email = email;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.profileData);
  }

  public setDocumentPhoneData(phone: string) {
    this.journeyService.registratioJourney.data.profileData.phoneNumber = phone;
    this.setIsCompleteStepData();
    this.journeyService.changeDataEvent(this.STEP_CODE, this.journeyService.registratioJourney.data.profileData);
  }

  setIsCompleteStepData() {
    this.journeyService.registratioJourney.data.profileData.isCompleted = this.profileDataIsComplete();
  }

  profileDataIsComplete(): boolean {
    const props = ['name', 'email', 'phoneNumber'];
    const objAddress = {
      name: this.journeyService.registratioJourney.data?.profileData?.name,
      email: this.journeyService.registratioJourney.data?.profileData?.email,
      PhoneNumber: this.journeyService.registratioJourney.data?.profileData?.phoneNumber
    };

    return this.journeyService.registratioJourney.data.profileData !== undefined
      && this.isAllProps(this.journeyService.registratioJourney.data.profileData, props)
      && this.isNotEmpty(objAddress);
  }

  isAllProps(data: any, props: string[]): boolean {
    return props.every((prop) => data.hasOwnProperty(prop));
  }

  isNotEmpty(data: any): boolean {
    return Object.values(data).every(value => !!value);
  }
}
